import { Box, Typography } from '@mui/material';
import React from 'react';

interface TermsSectionItemProps {
    title: string;
    description: string;
}

const TermsSectionItem: React.FC<TermsSectionItemProps> = ({ title, description }) => {
    return (
        <Box display="flex" flexDirection="column" gap={1}>
            <Typography variant="h6" color="text2.secondary" fontWeight={600}>{title}</Typography>
            <Typography color="text2.secondary">{description}</Typography>
        </Box>
    );
};

export default TermsSectionItem;
